import React, { Component } from "react";
import styled from "styled-components";
import DesktopMenu from "../navigation/DesktopMenu";
import MobileMenu from "../navigation/MobileMenu";
import { NavLink } from "react-router-dom";
import logo from "../../assets/img/logo.svg";

class Header extends Component {
  render() {
    return (
      <PageHeader>
        <DesktopMenu />
        <MobileLogoContainer>
          <MenuLink exact to="/">
            <Logo src={logo} />
          </MenuLink>
        </MobileLogoContainer>
        <MobileMenu />
      </PageHeader>
    );
  }
}

const PageHeader = styled.div`
  background-color: #000000;
  width: 100%;
  text-align: center;
  z-index: 100;
  position: relative;
  padding: 0;
  @media only screen and (max-width: 980px) {
    position: fixed;
    height: 65px;
  }
`;

const MobileLogoContainer = styled.div`
  display: none;
  @media only screen and (max-width: 980px) {
    display: block;
    width: 100%;
    height: 65px;
  }
`;

const Logo = styled.img`
  @media only screen and (max-width: 980px) {
    height: 45px;
    padding: 10px 0;
  }
`;

const MenuLink = styled(NavLink)`
  text-decoration: none;
  color: #ffffff;
  width: 100%;
  display: block;
  text-transform: uppercase;
`;

export default Header;



// WEBPACK FOOTER //
// ./src/components/layout/PageHeader.js